import '../FormModal/style.scss'
import { Button, Input, message, Modal } from 'antd'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as Api from '@/api/home'
import { showPlanModal } from '@/libs/util'
import VoiceModal from '@/views/create-video/components/VoiceModal'
import { RightOutlined } from '@ant-design/icons'

interface IProps {
  open: boolean
  data: any
  onCancel?: () => void
  onSuccess?: (form?: any) => void
}

const AvatarFormModalEdit: FC<IProps> = (props) => {
  const { t } = useTranslation(['avatar', 'system'])
  const { open, data, onCancel, onSuccess } = props
  const [selectVoice, setSelectVoice] = useState<any>()
  const [avatar, setAvatar] = useState<any>()
  const [voiceModalOpen, setVoiceModalOpen] = useState(false)
  const [form, setForm] = useState<any>({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (open) {
      setSelectVoice(undefined)
      setForm({
        title: '',
        description: '',
        self_introduction: ''
      })
      getDetail()
    }
  }, [open])

  const getDetail = async () => {
    const res = await Api.getDigitalHumanGroupDetail(data.id)
    const { digital_human_group, tts_voice } = res
    if (digital_human_group) {
      setForm({
        title: digital_human_group.title,
        description: digital_human_group.description,
        self_introduction: digital_human_group.self_introduction
      })
      setAvatar(digital_human_group.face_url || digital_human_group.cover_url)
    }

    if (tts_voice) {
      setSelectVoice({
        ...tts_voice,
        parent_id: digital_human_group?.tts_voice_is_community ? tts_voice.group_id : undefined
      })
    }
  }

  const onVoiceChange = (voice: any) => {
    setSelectVoice(voice)
  }

  const onFormChange = (key: string, e: any) => {
    setForm({
      ...form,
      [key]: e.target.value
    })
  }

  const submitForm = async () => {
    const { title } = form
    if (!title?.trim()) {
      return message.warning(t('avatar.enter_name_warning'))
    }
    try {
      setLoading(true)
      const postData = {
        ...form,
        tts_voice_id: selectVoice?.id,
        tts_voice_is_community: !!selectVoice?.parent_id
      }
      await Api.updateDigitalGroup(data.id, postData)
      onCancel?.()
      onSuccess?.(form)
      message.success(t('system.update_success'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Modal
        title={t('avatar.edit_avatar')}
        className="commom-modal avatar-form-modal"
        footer={null}
        width={700}
        onCancel={() => onCancel?.()}
        open={open}
        maskClosable={false}
        zIndex={99}
      >
        <div className="avatar-form-modal-content">
          <div className="wrapper">
            <div className="wrapper__left">
              <div className="photo">{avatar && <img src={avatar} />}</div>
            </div>
            <div className="wrapper__right">
              <div className="form-item">
                <div className="title">
                  <label className="red">*</label>
                  <label>{t('avatar.name')}</label>
                </div>
                <div className="content">
                  <Input
                    value={form?.title}
                    placeholder={t('avatar.name_placeholder')}
                    maxLength={20}
                    onChange={onFormChange?.bind(this, 'title')}
                  />
                </div>
              </div>

              <div className="form-item">
                <div className="title">{t('avatar.self_introduction')}</div>
                <div className="content">
                  <Input.TextArea
                    placeholder={t('avatar.self_intro_placeholder')}
                    maxLength={200}
                    value={form?.self_introduction}
                    onChange={onFormChange?.bind(this, 'self_introduction')}
                  />
                </div>
              </div>

              <div className="form-item">
                <div className="title">{t('avatar.voice')}</div>
                <div className="content">
                  <div className="form-voice-box" onClick={() => setVoiceModalOpen(true)}>
                    {selectVoice ? (
                      <>
                        <div className="left">
                          <img src={selectVoice?.group_cover_url} />
                        </div>
                        <div className="center ellipsis">
                          <span>{selectVoice?.group_title}</span>
                          <span className="name">{selectVoice?.display_name}</span>
                        </div>
                      </>
                    ) : (
                      <div className="center">{t('avatar.select_voice')}</div>
                    )}
                    <div className="right">
                      <RightOutlined />
                    </div>
                  </div>
                </div>
              </div>
              <div className="footer">
                <Button loading={loading} type="primary" onClick={submitForm}>
                  {loading ? t('system.updating') : t('avatar.finish_edit')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <VoiceModal
        open={voiceModalOpen}
        selectTts={selectVoice}
        onCancel={() => setVoiceModalOpen(false)}
        upgradePlan={showPlanModal}
        onSelect={onVoiceChange}
      />
    </>
  )
}

export default AvatarFormModalEdit
